import Seo from "@/components/Seo";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import CategoryGrid from "@/components/CategoryGrid";
import ProductShelf from "@/components/ProductShelf";
import ManifestoChapters from "@/components/ManifestoChapters";
import TrustStrip from "@/components/TrustStrip";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Weird O'Clock — Curated Surreal Clocks & Eccentric Home Decor"
        siteName="Weird O'Clock"
        description="Clocks that melt, mirrors that misbehave, decor that refuses to be ignored. Shop quirky clocks and unusual home decor with secure Shopify checkout."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Weird O'Clock",
          description:
            "Curated surreal clocks and eccentric home decor. Functional art for homes with a pulse.",
        }}
      />
      <HeroSection />
      <EditorialMarquee />
      <CategoryGrid />
      <ProductShelf
        eyebrow="02 — The main event"
        title="Weird"
        accent="clocks"
        linkTo="/collections/weird-clocks"
        collectionHandle="weird-clocks"
        query="clock"
        limit={4}
        exclude={["doggy"]}
        preferHandles={[
          "klein-blue-moon-phase-clock",
          "vinyl-record-clock-with-stand",
          "cheese-shaped-wall-clock",
          "12-inch-bagel-wall-clock",
        ]}
      />
      <ProductShelf
        eyebrow="03 — Beyond time"
        title="Quirky"
        accent="decor"
        linkTo="/collections/odd-decor"
        collectionHandle="odd-decor"
        query="decor OR vase OR lamp OR candle"
        limit={4}
      />
      <ManifestoChapters />
      <ProductShelf
        eyebrow="04 — Fresh from the strange"
        title="New"
        accent="arrivals"
        linkTo="/shop"
        sortKey="CREATED_AT"
        reverse
        limit={4}
      />
      <ProductShelf
        eyebrow="05 — Crowd favourites"
        title="Best"
        accent="sellers"
        linkTo="/shop"
        sortKey="BEST_SELLING"
        limit={4}
      />
      <TrustStrip />
    </main>
  );
}
